

const RSIdemographics = ({
    pageTitle,
    Header,
    currentPage,
    Back,
    handleBackClick,
    pageRef,
    Logo,
    logo,
    Head,
    FormInput,
    DobInput,
    TextInput,
    SelectInput,
    DynamicCheckbox,
    MedicalPortalAccess,
    Paragraph,
    ButtonGroup,
    FaTrash,
    FaPlus,
    PatientRegistrationFormData,
    setPatientRegistrationFormData,
    handleInputChange,
    handlePortalChange,
    handleZipSearch,
    handleFamilyContentChange,
    handleRemoveFamilyMember,
    handleAddMember,
    genderOptions,
    languageOptions,
    ethnicityOptions,
    raceOptions,
    emergencyRelationshipOptions,
    invalidFields,
    nextLoader,
    isSubmitted,
    fileUpload,
    handleEdit,
    handleNext,
    handleFormSubmit,
    validateForm,
    showAllPages,
    handleCheckChange,
    DOBPickerInput,
    FamilyMemberConsent
}) => {
    return (
        <>
            <Header pageTitle={pageTitle} />
            <form className="bg-white">
                {currentPage > 1 && (
                    <Back onClick={handleBackClick} />
                )}
                <div ref={pageRef} className="max-w-5xl w-full bg-white">
                    <Logo src={logo} />
                    <Head title={pageTitle} />
                    {/* Page 1 */}
                    {(currentPage === 1 || showAllPages) && (
                        <div className="px-1 mx-20 py-2 bg-white">

                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: true,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: true,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* DOB */}
                                <DOBPickerInput
                                    id="dob"
                                    label="DOB"
                                    value={PatientRegistrationFormData.dob}
                                    onChange={(date) => {
                                        const formattedDate = date
                                            ? `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
                                                .getDate()
                                                .toString()
                                                .padStart(2, "0")}/${date.getFullYear()}`
                                            : "";
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            dob: formattedDate,
                                        }));
                                    }}
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("DOB")}
                                />



                                <div className="flex items-center space-x-2">
                                    <SelectInput
                                        id="gender"
                                        label="Gender *"
                                        options={genderOptions}
                                        value={PatientRegistrationFormData.gender}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                gender: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader}
                                        invalid={invalidFields.includes("Gender") && !PatientRegistrationFormData.gender}
                                        errorMessage="Please select a gender."
                                    />

                                </div>
                            </div>

                            {/* Address */}
                            <TextInput
                                id="address"
                                label="Address"
                                required
                                value={PatientRegistrationFormData.address}
                                onChange={handleInputChange}
                                disabled={nextLoader}
                                invalid={invalidFields.includes("Address") && !PatientRegistrationFormData.address}
                            />

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 gap-4">

                                <div className="flex flex-col">
                                    <FormInput
                                        id="zip"
                                        label="Zip"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["zip"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("zip") && !PatientRegistrationFormData["zip"]}
                                        required={true}
                                        onZipSearch={handleZipSearch}
                                    />

                                    {!nextLoader && (
                                        <p className="text-sm text-muted-foreground mt-1">
                                            City and State can be filled by using Zip
                                        </p>
                                    )}
                                </div>


                                <FormInput
                                    key="city"
                                    id="city"
                                    label="City"
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData["city"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("City") && !PatientRegistrationFormData["city"]}
                                    required={true}
                                />

                                <FormInput
                                    key="state"
                                    id="state"
                                    label="State"
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData["state"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("State") && !PatientRegistrationFormData["state"]}
                                    required={true}
                                />
                            </div>
                            <Paragraph>We may use your phone number for appointment reminders and care-related communication.</Paragraph>

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* cellphone */}
                                <FormInput
                                    key="cellphone"
                                    id="cellphone"
                                    label="Cell Phone"
                                    type="number"
                                    disabled={nextLoader}
                                    value={PatientRegistrationFormData["cellphone"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Cell Phone") && !PatientRegistrationFormData["cellphone"]}
                                    required={true}
                                />


                            </div>

                            <div className="text-sm text-muted-foreground mt-1 mb-2 gap-4 flex-row">


                                {/* reminderPhone */}
                                <DynamicCheckbox
                                    label="Yes, I agree to receive occasional text messages from Retina Specialty Institute about updates, services, and events. Message and data rates may apply. Message frequency varies. I understand that I can opt-out at any time."
                                    fieldName="consentToText"
                                    id="consentToText"
                                    isChecked={PatientRegistrationFormData.consentToText}
                                    onChange={handleCheckChange}
                                    isDisabled={nextLoader}
                                    showError={invalidFields.includes("consentToText")}
                                />
                            </div>

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* Preferred Language */}
                                <SelectInput
                                    id="preferredLanguage"
                                    label="Preferred Language"
                                    options={languageOptions}
                                    value={PatientRegistrationFormData.language}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            language: e.target.value,
                                        }))
                                    }
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("preferredLanguage") && !PatientRegistrationFormData.language}
                                    errorMessage="Please select a language."
                                />

                                {/* ssn */}

                                <FormInput
                                    key="ssn"
                                    id="ssn"
                                    label="Social Security Number"
                                    type="number"
                                    disabled={nextLoader}
                                    value={PatientRegistrationFormData["ssn"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("SSN")}
                                    required={false}
                                />
                            </div>

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <SelectInput
                                    id="ethnicity"
                                    label="Ethnicity"
                                    options={ethnicityOptions}
                                    value={PatientRegistrationFormData.ethnicity}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            ethnicity: e.target.value,
                                        }))
                                    }
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("ethnicity")}
                                />

                                <SelectInput
                                    id="race"
                                    label="Race"
                                    options={raceOptions}
                                    value={PatientRegistrationFormData.race}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            race: e.target.value,
                                        }))
                                    }
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("race")}
                                    errorMessage="Please select a race."
                                />
                            </div>

                        </div>
                    )}
                    {(currentPage === 2 || showAllPages) && (
                        <div className="max-w-5xl w-full bg-white">
                            <div className="px-1 mx-20 py-2 bg-white">

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* referred by */}

                                    <FormInput
                                        key="referredBy"
                                        id="referredBy"
                                        label="Referred By"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["referredBy"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Referred By")}
                                        required={true}
                                    />

                                    {/* family doctor */}
                                    <FormInput
                                        key="familyDoctor"
                                        id="familyDoctor"
                                        label="Family Doctor"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["familyDoctor"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Family Doctor")}
                                        required={true}
                                    />

                                </div>

                                <Paragraph>We use your email to send important information related to your care, including appointment confirmations, forms, and follow-up instructions.</Paragraph>


                                <TextInput
                                    id="email"
                                    label="Email"
                                    value={PatientRegistrationFormData.email}
                                    onChange={handleInputChange}
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("Email") && !PatientRegistrationFormData.email}
                                />

                                {
                                    Boolean(PatientRegistrationFormData?.email?.trim()) && (
                                        <div className="text-sm text-muted-foreground mt-1 mb-2 gap-4 flex-row">
                                            <DynamicCheckbox
                                                label="Yes, I would like to receive occasional updates from Retina Specialty Institute, including helpful eye care information, new services, and practice updates. I understand I can unsubscribe at any time."
                                                fieldName="emailConsent"
                                                id="emailConsent"
                                                isChecked={PatientRegistrationFormData.emailConsent}
                                                onChange={handleCheckChange}
                                                isDisabled={nextLoader}
                                                showError={invalidFields.includes("emailConsent")}
                                            />
                                        </div>
                                    )
                                }
                                {/* Portal */}
                                <MedicalPortalAccess
                                    id="portal"
                                    label="Would you like to have access to your Medical Records / Portal?"
                                    portalValue={PatientRegistrationFormData.portal}
                                    onChange={handlePortalChange}
                                    isDisabled={nextLoader}
                                />

                                <div className="border-t-4 border-b-4 border-gray-300 p-4">
                                    {/* Emergency Contact Information Heading */}
                                    <p className="text-lg font-semibold text-center text-black">
                                        Emergency Contact Information
                                    </p>
                                </div>


                                <div className="mb-4 mt-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* Name */}

                                    <FormInput
                                        key="emergencyName"
                                        id="emergencyName"
                                        label="Name"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["emergencyName"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Emergency Name")}
                                        required={false}
                                    />

                                    {/* relationship */}
                                    <SelectInput
                                        id="emergencyRelationship"
                                        label="Relationship"
                                        options={emergencyRelationshipOptions}
                                        value={PatientRegistrationFormData.emergencyRelationship}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                emergencyRelationship: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader}
                                        invalid={invalidFields.includes("Emergency Relationship")}
                                        errorMessage="Please select a emergency relationship."
                                    />
                                </div>

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <FormInput
                                        key="emergencyPhone"
                                        id="emergencyPhone"
                                        label="Phone"
                                        type="number"
                                        disabled={isSubmitted}
                                        value={PatientRegistrationFormData["emergencyPhone"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Emergency Phone")}
                                        required={false}
                                    />
                                </div>

                                <div>
                                    {invalidFields.includes('emergencyFields') && (
                                        <p style={{ color: 'red' }}>Fill out all the fields in the emergency contact information!</p>
                                    )}
                                </div>

                            </div>
                        </div>
                    )
                    }

                    {(currentPage === 3 || showAllPages) && (
                        <div className="max-w-5xl w-full bg-white">
                            <FamilyMemberConsent
                                familyMembers={PatientRegistrationFormData.familyMembers}
                                handleFamilyChange={handleFamilyContentChange}
                                handleAddMember={handleAddMember}
                                handleRemoveFamilyMember={handleRemoveFamilyMember}
                                DOBPickerComponent={DOBPickerInput} // pass your component
                                fileUpload={fileUpload}
                                nextLoader={fileUpload}
                                FaTrash={FaTrash}
                                FaPlus={FaPlus}
                                title={'Retina Specialty Institute'}
                            />
                        </div>
                    )
                    }
                </div>


                <ButtonGroup
                    isSubmitted={isSubmitted}
                    currentPage={currentPage}
                    handleEdit={handleEdit}
                    handleNext={handleNext}
                    handleFormSubmit={handleFormSubmit}
                    validateForm={validateForm}
                />
            </form >
        </>
    );
};

export default RSIdemographics;


